import React, { useState } from 'react';
import { getImages } from '../const';
import { Link } from 'react-router-dom';

const AvgRetailTable = ({data, numberFormatter}) => {
    
    const [sortConfig, setSortConfig] = useState({ key: 'dom_is', direction: '' });

    const sortedData = React.useMemo(() => {
        let sortableData = [...data];
    
        if (sortConfig !== null) {
            sortableData.sort((a, b) => {
                let aValue, bValue;
    
                // Handle computed `priceDiff` separately
                if (sortConfig.key === 'priceDiff') {
                    aValue = a.price_fs - a.avg_price;
                    bValue = b.price_fs - b.avg_price;
                } else {
                    aValue = a[sortConfig.key];
                    bValue = b[sortConfig.key];
                }
    
                if (aValue < bValue) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
    
        return sortableData;
    }, [data, sortConfig]);
    

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };
    const [expandedRow, setExpandedRow] = useState(null);

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };
    const [rowCount, setRowCount] = useState(9);
    const [hideViewMoreBtn, setHideViewMoreBtn] = useState(false);
    const handleViewMoreBtn = () => {
        setRowCount(sortedData.length)
        setHideViewMoreBtn(true)
    }
    return (
        <div className='custom-table avg-retail-table scrollbar-vertical'>
            <div className='sv-body'>
                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th
                                className={
                                    sortConfig.key === 'year_is'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'text-start ps-4 sort-asc'
                                            : 'text-start ps-4 sort-desc'
                                        : 'text-start ps-4'
                                }
                                
                                onClick={() => requestSort('year_is')}>
                                Year Make Model Trim 
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'price_fs'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('price_fs')}
                            >
                                List Price
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'avg_price'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('avg_price')}
                            >
                                Avg. Retail
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'priceDiff'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('priceDiff')}
                            >Difference
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th
                                className={
                                    sortConfig.key === 'miles_fs'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('miles_fs')}
                            >
                                Miles
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            {/* <th
                                className={
                                    sortConfig.key === 'avg_miles'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('avg_miles')}
                            >
                                Avg. Miles
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th> */}
                            <th
                                className={
                                    sortConfig.key === 'dom_is'
                                        ? sortConfig.direction === 'ascending'
                                            ? 'sort-asc'
                                            : 'sort-desc'
                                        : ''
                                }
                                onClick={() => requestSort('dom_is')}
                            >Days on Lot
                                <span className='sort-icon pm-sort-icon ms-3'></span>
                            </th>
                            <th>
                                VDP Link
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.slice(0, rowCount).map((v, i) => {
                            const priceDiff = v.price_fs - v.avg_price;
                            return (
                                <tr key={i}>
                                    <td className='text-start'>{v.year_is + " " + v.make_ss + " " + v.model_ss + " " + v.trim_ss}</td>
                                    
                                    <td>{numberFormatter(v.price_fs,true)}</td>
                                    <td>{numberFormatter(v.avg_price,true)}</td>
                                    <td>
                                        {priceDiff < 0 ? 
                                            <div className='text-green'><i className="bi bi-caret-down-fill"></i> {numberFormatter(priceDiff,true)}</div> 
                                            :
                                            <div><i className="bi bi-caret-up-fill text-red"></i> {numberFormatter(priceDiff,true)}</div> 
                                        }
                                    </td>
                                    <td>{numberFormatter(v.miles_fs)}</td>
                                    {/* <td>{numberFormatter(v.avg_miles)}</td> */}
                                    <td>{numberFormatter(v.dom_is)}</td>
                                    <td>
                                        {v.vdp_url ? <a href={v.vdp_url} className='red-transparent-btn text-uppercase md-btn d-inline-block mnw-85' target="_blank">View</a> : <span></span>}
                                        {/*<Link to="/" className='red-transparent-btn text-uppercase md-btn d-inline-block mnw-85'>View</Link>*/}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {!hideViewMoreBtn &&
                <div className='text-center pt-3'>
                    <button type='button' className='red-btn text-uppercase w-206' onClick={handleViewMoreBtn}>View More</button>
                </div>
            }
        </div>
    );
};

export default AvgRetailTable;
